import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa"; // Import icons
import Button from "./shared/Button";
import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

const Hero = () => {
  return (
    <div className="mb-16 mx-12 sm:mx-16">
      {/* Button for screens >= 640px */}
      <div className="sm:flex justify-start">
        <div className="hidden sm:block pr-6 pl-2.5 sm:pt-10">
          <Button
            icon={<FaEnvelope size={24}/>}
            color="bg-red-700" // Button color
            url="https://mail.google.com/mail/?view=cm&fs=1&to=pilarebhushan4@gmail.com&su=Hello&body=Hi%20there!" 
          />
        </div>
        <motion.div
          className=""
          initial={{ opacity: 0, y: 20 }} // Initial state
          animate={{ opacity: 1, y: 0 }} // Animated state
          transition={{ duration: 0.6 }} // Animation duration
        >
          <motion.h1
            className="myName font-extrabold sm:text-5xl lg:text-7xl"
            initial={{ opacity: 0, y: 20 }} // Initial state
            animate={{ opacity: 1, y: 0 }} // Animated state
            transition={{ duration: 0.6, delay: 0.3 }} // Animation duration and delay
          >
            Hello ! I'm Bhushan
          </motion.h1>
          <motion.p
            className="text-xl font-extrabold font-mono py-5 sm:text-3xl lg:text-5xl"
            initial={{ opacity: 0, y: 20 }} // Initial state
            animate={{ opacity: 1, y: 0 }} // Animated state
            transition={{ duration: 0.6, delay: 0.6 }} // Animation duration and delay
          >
            I Build Creative and Interactive Full Stack Web Applications.
          </motion.p>
        </motion.div>
      </div>

      <div className="mb-7 md:flex justify-between sm:mx-12">
        <p className="text-gray-400 font-mono text-sm mb-5 sm:px-14 lg:text-lg md:py-10 lg:pt-10">
          As a full stack web developer, my expertise lies in creating seamless and
          intuitive user experiences. I specialize in using cutting-edge
          technologies to produce high-quality web applications. Specifically, I
          have vast knowledge of ReactJS and NodeJS, which allow me to build
          complex and dynamic applications with ease.
        </p>
        <div className="overflow-hidden max-w-full">
          <Player
            autoplay
            loop
            src="https://assets6.lottiefiles.com/packages/lf20_m64r7cwa.json"
            className="xl:!h-[400px] xl:!w-[600px] lg:!h-[280px] lg:!w-[480px] md:!h-[240px] md:!w-[300px] !h-[180px] !w-full max-w-[360px]"
          />
        </div>
      </div>

      <div className="relative z-20 flex justify-around w-full mt-12 sm:hidden">
        <Button
          icon={<FaEnvelope size={24} />}
          color="bg-red-500"
          url="https://mail.google.com/mail/?view=cm&fs=1&to=pilarebhushan4@gmail.com&su=Hello&body=Hi%20there!"
        />
        <Button
          icon={<FaGithub size={24} />}
          color="bg-gray-800"
          url="https://github.com/Bhushan-04"
        />
        <Button
          icon={<FaLinkedin size={24} />}
          color="bg-blue-900"
          url="https://www.linkedin.com/in/bhushan-pilare-4a7713154/"
        />
      </div>
    </div>
  );
};

export default Hero;
